import { useNavigate } from 'react-router-dom';
import { Grid as Grid, Button, Container, Typography } from '@mui/material';
import { Send, CloudUpload, Campaign } from '@mui/icons-material';

const HomePage = () => {
    const navigate = useNavigate();
    return (
        <Container sx={{ mt: 8 }}>
            <Typography variant="h4" sx={{ mb: 4 }}>Admin Dashboard</Typography>
            {/* Use Grid2 (imported as Grid) which supports the modern size prop */}
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Button fullWidth variant="contained" size="large" onClick={() => navigate('/broadcast')} startIcon={<Send />}>
                        Push Broadcast
                    </Button>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Button fullWidth variant="contained" size="large" onClick={() => navigate('/media')} startIcon={<CloudUpload />}>
                        Media Registry
                    </Button>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Button fullWidth variant="contained" size="large" onClick={() => navigate('/ads')} startIcon={<Campaign />}>
                        Ad Campaigns
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};
export default HomePage;